var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"a340f95e863819b03b29b312cbfb2257ac93ee24"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["tools-ui@pooltogether"]={id:"a340f95e863819b03b29b312cbfb2257ac93ee24"};
      